import request from "@/utils/request";
import Qs from "qs";

const api = {
  findByPid: "/api/dic/findByPid",
  findPage: "/api/dic/findPage",
  add: "/api/dic/add",
  addItem: "/api/dic/addItem",
  update: "/api/dic/update",
  updateDicStatus: "/api/dic/updateDicStatus"
};

/**
 * 根据父节点查询所有字典类型
 * @param pid
 */
export function findByPid(parameter) {
  return request({
    url: api.findByPid,
    method: "get",
    params: parameter
  });
}

/**
 * 根据父节点查询所有字典分页
 * @param pid
 */
export function findPage(parameter) {
  return request({
    url: api.findPage,
    method: "get",
    params: parameter
  });
}

/**
 * 添加字典类别
 * @param parameter
 */
export function add(parameter) {
  return request({
    url: api.add,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

/**
 * 添加字典类别下级
 * @param parameter
 */
export function addItem(parameter) {
  return request({
    url: api.addItem,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

/**
 * 修改字典
 * @param parameter
 */
export function update(parameter) {
  return request({
    url: api.update,
    method: "post",
    data: Qs.stringify(parameter)
  });
}
/**
 * 根据id修改字典状态
 * @param parameter
 */
export function updateDicStatus(parameter) {
  return request({
    url: api.updateDicStatus,
    method: "post",
    data: Qs.stringify(parameter)
  });
}
